module.exports = {"title":"Edit Reply","replyStatus":"Reply Status","answered":"Answered","checking":"In Review","contentPlaceholder":"Enter content.","updatedAlert":"Your reply has been updated.","typeService":"Service","typeEvent":"Event","typeUpdate":"Update"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs106.json
// module id = emJx
// module chunks = 2